import React from 'react';
import { View, Text, StyleSheet, TouchableOpacity } from 'react-native';
import { FeatureFlagAttributes } from '@/types/admin/featureFlags';
import { useAdminColors } from '@/hooks/admin/useAdminColors';
import { getOverrideCount, formatOverrideText } from '../utils/featureFlagsUtils';

interface PropertyFlagRowProps {
  flag: FeatureFlagAttributes;
  onPress: () => void;
}

export const PropertyFlagRow: React.FC<PropertyFlagRowProps> = ({ flag, onPress }) => {
  const { redesign, admin, semantic } = useAdminColors();
  const overrideCount = getOverrideCount(flag);
  const hasOverrides = overrideCount > 0;

  return (
    <TouchableOpacity
      key={`${flag.organization_id}-${flag.property_id || flag.id}`}
      style={[
        styles.propertyRow,
        {
          backgroundColor: admin.dataTable.row,
          borderBottomColor: redesign.card.border,
        },
      ]}
      onPress={onPress}
      activeOpacity={0.7}
    >
      <View style={styles.propertyContent}>
        <View style={styles.propertyLeft}>
          <Text
            style={[styles.propertyName, { color: redesign.text.primary }]}
            numberOfLines={1}
          >
            {flag.propertyName}
          </Text>
        </View>

        <View style={styles.propertyRight}>
          {hasOverrides && (
            <View
              style={[
                styles.overrideBadge,
                { backgroundColor: admin.selector.itemSelectedBg },
              ]}
            >
              <Text style={[styles.overrideText, { color: semantic.text.link }]}>
                {formatOverrideText(overrideCount)}
              </Text>
            </View>
          )}
        </View>
      </View>
    </TouchableOpacity>
  );
};

const styles = StyleSheet.create({
  propertyRow: {
    borderBottomWidth: 1,
  },
  propertyContent: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: 16,
  },
  propertyLeft: {
    flex: 1,
  },
  propertyName: {
    fontSize: 14,
    fontWeight: '600',
  },
  propertyRight: {
    alignItems: 'flex-end',
  },
  overrideBadge: {
    paddingHorizontal: 12,
    paddingVertical: 4,
    borderRadius: 12,
  },
  overrideText: {
    fontSize: 12,
    fontWeight: '500',
  },
});
